import { backend1, backend2 } from './device_webgl.js';

/**
 * The WebGL1 backend
 * @public
 */ const backendWebGL1 = backend1;
/**
 * The WebGL2 backend
 * @public
 */ const backendWebGL2 = backend2;

export { backendWebGL1, backendWebGL2 };
//# sourceMappingURL=index.js.map
